<template>
  <div id="interior-box">
    <h3 class="center">Besonderes</h3>
    <br>
    <image-gallery :images="galleryImages"/>
  </div>
</template>

<script>
export default {
  name: "Special",
  data() {
    return {
      galleryImages:this.importImages()
    };
  },
  methods:{
    importImages(){
      function importAll(r) { return r.keys().sort().map(r); }
      var images = importAll(require.context('@/assets/media/special', false, /img\d+\.(png|jpe?g|svg)$/));
      return images.map(i=>{return {src:i}})
    }
  }
};
</script>

<style>

</style>
